module.exports = __webpack_public_path__ + "static/media/customer-marker.8ea9df2b.svg";